import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common'
import { Component, DestroyRef, Inject, inject, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatTabsModule } from '@angular/material/tabs'
import { MasonryItemDirective } from '@shared/directives/masonry-item.directive'
import { HotelRepository } from '@core/services/repositories/hotel.repository'
import { SkeletonComponent } from '@shared/components/skeleton/skeleton.component'
import { PlpBreadcrumbComponent } from '../search-result/components/plp-breadcrumb/plp-breadcrumb.component'


@Component({
  selector: 'iho-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatTabsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatButtonToggleModule,
    PlpBreadcrumbComponent
]
})

export class PolicyComponent implements OnInit {
  listBreadcrumb: any;
  constructor( ) {
  }
  ngOnInit(): void {
    this.listBreadcrumb = [
      {
        "@id": "/",
        "name": "رزرو هتل"
      },
      {
        "@id": "#",
        "name": "قوانین و مقررات رزرو اینترنتی"
      }
    ]
  
}



}
